import { Button, useTheme } from "@mui/material";
import { CopyPlus } from "lucide-react";
import { useState } from "react";
import type { JourneyCase } from "../dtos";
import CloneStepsDialog from "./clone-steps-dialog";
import { secondaryButtonSx } from "./field-shell";

/**
 * §Clone-steps: "Copy data from another application" on a case that already exists — opens
 * `CloneStepsDialog` in COPY mode, target fixed to the SELECTED application. Rendered only when the
 * lead runs at least two applications (`case-header-actions.tsx` gates that); no extra permission check
 * here — workflow-manager enforces writer/step-hold authority per step at PLAN and again at APPLY,
 * and a refusal surfaces through the dialog's own error toast.
 */
const CopyStepsButton = ({ caseUid, cases }: { caseUid: string; cases: JourneyCase[] }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        disableElevation
        onClick={(event) => {
          // the sticky header row sits inside clickable surfaces on mobile — never bubble
          event.stopPropagation();
          setOpen(true);
        }}
        startIcon={<CopyPlus size={14} />}
        sx={{ ...secondaryButtonSx(theme), textTransform: "none" }}
      >
        Copy data from another application
      </Button>
      <CloneStepsDialog
        open={open}
        onClose={() => setOpen(false)}
        mode="copy"
        cases={cases}
        targetCaseUid={caseUid}
      />
    </>
  );
};

export default CopyStepsButton;
